/* eslint-disable react/prop-types */
import React from "react";
import "./sidebar.css";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setParentCourse } from "../Action/courseAction";

function SidebarModule(props) {
  const dispatch = useDispatch();
  const currentURLarr = useLocation().pathname.split("/");
  let link = currentURLarr[currentURLarr.length - 1];

  const { globalEditMode, isFirstTimeLoggedIn } = useSelector((state) => ({
    globalEditMode: state.courseReducer?.isEditMode,
    isFirstTimeLoggedIn: state.courseReducer?.isFirstTimeLoggedIn,
  }));
  const handleResetEditMode = () => {
    if (globalEditMode) {
      dispatch(setParentCourse("isEditMode", false));
    }
    dispatch(setParentCourse("isFirstTimeLoggedIn", false));
    props?.handleResetEditMode();
  };

  return (
    <div className="accordion subAccordion" id={"accordion" + props?.keyval}>
      {props.data.map((val, key) => {
        if (val.subNav === undefined) {
          return (
            <li
              key={key}
              id={key}
              onClick={props?.handleResetEditMode}
              className={
                val.path === link || (isFirstTimeLoggedIn && key === 0)
                  ? "sideListRow active text-capitalize"
                  : "sideListRow text-capitalize"
              }
            >
              <Link to={val.path} onClick={props?.handleCloseSidebar}>{val.title.toLowerCase()}</Link>
              <span></span>
            </li>
          );
        } else {
          return (
            <div className="accordion-item rounded-0 border-0 " key={key}>
              <h2
                className="accordion-header "
                id={"SubMenuheading" + +props?.keyval + key}
              >
                <button
                  className="accordion-button collapsed text-capitalize"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={"#SubMenucollapse" + props?.keyval + key}
                  aria-expanded="false"
                  aria-controls={"SubMenucollapse" + props?.keyval + key}
                >
                  {val.title.toLowerCase()}
                </button>
              </h2>
              <div
                id={"SubMenucollapse" + props?.keyval + key}
                className={`accordion-collapse collapse ${
                  isFirstTimeLoggedIn && key === 0 ? "show" : ""
                }`}
                aria-labelledby={"SubMenuheading" + props?.keyval + key}
                data-bs-parent={"#accordion" + props?.keyval}
              >
                <div className="accordion-body p-0">
                  {val.subNav.map((data, index) => {
                    return (
                      <li
                        key={index}
                        id={index}
                        onClick={() => handleResetEditMode(val.title)}
                        className={
                          data.path === link ||
                          (isFirstTimeLoggedIn && index === 0)
                            ? "sideListRow active text-capitalize"
                            : "sideListRow text-capitalize"
                        }
                      >
                        <Link to={data.path} onClick={props?.handleCloseSidebar}>{data.title.toLowerCase()}</Link>
                      </li>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
}

export default SidebarModule;
